module.exports = __webpack_public_path__ + "img/avatar.6e2f4d7f.svg";